import React, {useCallback, useRef, useState, useEffect, useLayoutEffect} from "react";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import Icon from "@amzn/meridian/icon";
import copyTokens from "@amzn/meridian-tokens/base/icon/copy";
import downloadLargeTokens from "@amzn/meridian-tokens/base/icon/download-large";
import thumbsUpTokens from "@amzn/meridian-tokens/base/icon/thumbs-up";
import thumbsDownTokens from "@amzn/meridian-tokens/base/icon/thumbs-down";
import HelpModal from "./HelpModel"
import FeedbackModal from "./FeedbackModel";
import Button from '@amzn/meridian/button';
import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';
import "./chatbot.scss";
import { feedbackPrompt} from "../../constants/placeholder";
import { postFeedback, FeedbackPayload, FeedbackKind } from '../../api/feedback';
import {getChatUrl} from "../../config/stageConfigs"
import { getCognitoJwtForGobot } from '../../auth/useCognitoAuth';
import { Auth as AmplifyAuth } from '@aws-amplify/auth';
import { CognitoConfig } from '../../auth/CognitoConfig';

type Message = { id: string; role: "user" | "assistant" | "feedback"; text: string };

const GOBOT_BADGE =
    'data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Crect%20width%3D%2224%22%20height%3D%2224%22%20rx%3D%2212%22%20fill%3D%22url(%23paint0_linear_1856_279494)%22%2F%3E%0A%3Cpath%20d%3D%22M11.2908%208.19058L12.1724%2010.3343C12.4493%2011.018%2012.994%2011.5493%2013.6679%2011.8265L15.8096%2012.7089C16.0635%2012.8106%2016.0635%2013.1848%2015.8096%2013.2864L13.6679%2014.1689C12.9848%2014.4461%2012.4493%2014.9912%2012.1724%2015.6657L11.2908%2017.8094C11.1846%2018.0635%2010.8154%2018.0635%2010.7092%2017.8094L9.8276%2015.6657C9.55066%2014.982%209.006%2014.4461%208.3321%2014.1689L6.1904%2013.2864C5.93653%2013.1848%205.93653%2012.8106%206.1904%2012.7089L8.3321%2011.8265C9.01523%2011.5493%209.55066%2011.0042%209.8276%2010.3343L10.7092%208.19058C10.8154%207.93647%2011.1846%207.93647%2011.2908%208.19058Z%22%20fill%3D%22white%22%2F%3E%0A%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M16.144%2010.9044L16.5841%209.83256C16.6308%209.71958%2016.692%209.61381%2016.7655%209.51788C16.7685%209.51403%2016.7714%209.5102%2016.7744%209.50639C16.8418%209.42038%2016.9193%209.34251%2017.0054%209.27473C17.0089%209.27194%2017.0125%209.26917%2017.016%209.26642C17.1114%209.19287%2017.2171%209.13159%2017.3311%209.08517L18.4025%208.64484C18.5299%208.5927%2018.5299%208.4073%2018.4025%208.35516L17.3311%207.91483C17.2181%207.86803%2017.1123%207.80679%2017.0163%207.7331C17.0127%207.73035%2017.0091%207.72757%2017.0056%207.72478C16.9196%207.6574%2016.8417%207.57992%2016.7739%207.49382C16.7709%207.49002%2016.768%207.48622%2016.765%207.48239C16.6916%207.38708%2016.6305%207.28145%2016.5841%207.16744L16.144%206.0956C16.0919%205.96813%2015.9065%205.96813%2015.8544%206.0956L15.4143%207.16744C15.3676%207.28042%2015.3064%207.38619%2015.2329%207.48212C15.2299%207.48597%2015.227%207.4898%2015.224%207.49361C15.1566%207.57962%2015.0791%207.65749%2014.993%207.72527C14.9895%207.72806%2014.9859%207.73083%2014.9824%207.73358C14.887%207.80713%2014.7813%207.86841%2014.6673%207.91483L13.5959%208.35516C13.4685%208.4073%2013.4685%208.5927%2013.5959%208.64484L14.6673%209.08517C14.7803%209.13197%2014.8861%209.19321%2014.9821%209.2669C14.9857%209.26965%2014.9893%209.27243%2014.9928%209.27522C15.0788%209.3426%2015.1567%209.42008%2015.2245%209.50618C15.2275%209.50998%2015.2304%209.51378%2015.2334%209.51761C15.3068%209.61292%2015.3679%209.71855%2015.4143%209.83256L15.8544%2010.9044C15.9065%2011.0319%2016.0919%2011.0319%2016.144%2010.9044Z%22%20fill%3D%22white%22%2F%3E%0A%3Cdefs%3E%0A%20%20%3ClinearGradient%20id%3D%22paint0_linear_1856_279494%22%20x1%3D%223.4675%22%20y1%3D%22-3.1721e-07%22%20x2%3D%2234.605%22%20y2%3D%2228.9399%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%0A%20%20%20%20%3Cstop%20stop-color%3D%22%238B46C6%22%2F%3E%0A%20%20%20%20%3Cstop%20offset%3D%221%22%20stop-color%3D%22%230077D9%22%2F%3E%0A%20%20%3C%2FlinearGradient%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E'

function renderInline(line: string): React.ReactNode[] {
    const parts = line.split(/(https?:\/\/\S+)/g);
    const out: React.ReactNode[] = [];

    parts.forEach((part, i) => {
        if (/^https?:\/\//i.test(part)) {
            let cleanUrl = part;
            let trailing = '';
            if (cleanUrl.endsWith(')')) {
                cleanUrl = cleanUrl.slice(0, -1);
                trailing = ')';
            }

            if (trailing) {
                out.push(
                    <React.Fragment key={`u-${i}`}>
                        <a href={cleanUrl} target='_blank' rel='noopener noreferrer'>
                            {cleanUrl}
                        </a>
                        {trailing}
                    </React.Fragment>,
                );
            } else {
                out.push(
                    <a key={`u-${i}`} href={cleanUrl} target='_blank' rel='noopener noreferrer'>
                        {cleanUrl}
                    </a>,
                );
            }
        } else {
            const boldChunks = part.split(/(\*\*[^*]+\*\*)/g).map((chunk, j) => {
                if (/^\*\*[^*]+\*\*$/.test(chunk)) {
                    return <strong key={`b-${i}-${j}`}>{chunk.slice(2, -2)}</strong>;
                }
                return <React.Fragment key={`t-${i}-${j}`}>{chunk}</React.Fragment>;
            });
            out.push(...boldChunks);
        }
    });

    return out;
}


function renderMd(md: string): JSX.Element {
    const lines = md.split(/\r?\n/);
    const out: React.ReactNode[] = [];

    let ul: React.ReactNode[] = [];
    const flushUl = () => {
        if (ul.length) {
            out.push(
                <ul key={`ul-${out.length}`} className="pf-md-ul">
                    {ul}
                </ul>
            );
            ul = [];
        }
    };

    let inSql = false;
    let sqlBuf: string[] = [];
    const flushSql = () => {
        if (!sqlBuf.length) return;

        const joined = sqlBuf.join(" ").replace(/\s+/g, " ").trim();
        if (joined) {
            out.push(
                <p key={`sql-${out.length}`} className="pf-md-p">
                    {renderInline(joined)}
                </p>
            );
        }
        sqlBuf = [];
    };

    lines.forEach((raw, i) => {
        const line = raw.trimEnd();
        if (inSql) {
            if (/^```/.test(line)) {
                inSql = false;
                flushSql();
            } else {
                sqlBuf.push(line.trim());
            }
            return;
        }
        if (/^```/i.test(line)) {
            if (/^```sql\b/i.test(line)) {
                flushUl();
                inSql = true;
                sqlBuf = [];
                return;
            } else {
                inSql = true;
                sqlBuf = [];
                return;
            }
        }

        const trimmed = line.trim();
        if (!trimmed) {
            flushUl();
            return;
        }
        // H1 / H2 / H3
        if (/^#\s+/.test(trimmed)) {
            flushUl();
            out.push(
                <div key={`h1-${i}`} className="pf-md-h1">
                    {renderInline(trimmed.replace(/^#\s+/, ""))}
                </div>
            );
            return;
        }
        if (/^##\s+/.test(trimmed)) {
            flushUl();
            out.push(
                <div key={`h2-${i}`} className="pf-md-h2">
                    {renderInline(trimmed.replace(/^##\s+/, ""))}
                </div>
            );
            return;
        }
        if (/^###\s+/.test(trimmed)) {
            flushUl();
            out.push(
                <div key={`h3-${i}`} className="pf-md-h3">
                    {renderInline(trimmed.replace(/^###\s+/, ""))}
                </div>
            );
            return;
        }
        if (/^-\s+/.test(trimmed)) {
            const item = trimmed.replace(/^-+\s+/, "");
            ul.push(<li key={`li-${i}`}>{renderInline(item)}</li>);
            return;
        }
        flushUl();
        out.push(
            <p key={`p-${i}`} className="pf-md-p">
                {renderInline(trimmed)}
            </p>
        );
    });
    flushSql();
    flushUl();

    return <>{out}</>;
}


AmplifyAuth.configure(CognitoConfig);

export default function GobotPage() {
    (async () => {
        try {
            await AmplifyAuth.currentSession();
        } catch {
            AmplifyAuth.federatedSignIn();
        }
    })();

    const [input, setInput] = useState("");
    const [messages, setMessages] = useState<Message[]>([]);
    const [toast, setToast] = useState<null | { id: string; msg: string }>(null);
    const showToast = useCallback((id: string, msg: string) => {
        setToast({id, msg});
        setTimeout(() => {
            setToast(curr => (curr && curr.id === id ? null : curr));
        }, 1200);
    }, []);
    const [feedbackToast, setFeedbackToast] = useState<{ id: string | null; which: 'up' | 'down' | null }>({
        id: null,
        which: null,
    });
    const [feedbackMap, setFeedbackMap] = useState<Record<string, 'up' | 'down'>>({});
    const [streamingId, setStreamingId] = useState<string | null>(null);
    const [feedbackTargetId, setFeedbackTargetId] = useState<string | null>(null);

    const [openHistory, setOpenHistory] = useState(true);

    const [thinking, setThinking] = useState(false);
    const [mode, setMode] = useState<"laborPlanning" | "packageData" | "businessReviewMetrics"
        | "trailerData" | "sitesInformation" | "huronNebulaTables" | "safety" | "general">("sitesInformation");
    const apiMode = {
        laborPlanning: "laborPlanning",
        packageData: "packageData",
        businessReviewMetrics: "businessReviewMetrics",
        trailerData: "trailerData",
        sitesInformation: "sitesInformation",
        huronNebulaTables: "huronNebulaTables",
        general: "general",
        safety: "safety"
    } as const;

    const MODE_PLACEHOLDER: Record<typeof mode, string> = {
        packageData: "Ask GoBot: For AI Meets Package Flow Intelligence…",
        trailerData: "Ask GoBot: Intelligent Trailer Engine…",
        laborPlanning: "Ask GoBot: Under the Roof Metrics for Labor Planning…",
        sitesInformation: "Ask GoBot: Smart Site Knowledge Repository…",
        businessReviewMetrics: "Ask GoBot: Real-time Business Intelligence Engine…",
        huronNebulaTables: "ASK GoBot: Intelligent Domain Knowledge Assistant…",
        safety: "Ask GoBot: Safety Related…",
        general: "Ask GoBot: General Related …",
    };

    const SUGGESTIONS = [
        "How many dock doors does OAK5 has?",
        "When was OAK5 site launched?",
        "What is the mechanical equipment’s that BFI5 has?",
        "Does OAK5 do cross-dock volume?",
    ];

    const onPickSuggestion = (q: string) => {
        if (thinking) return;
        setInput(q);
    };

    const [helpModalOpen, setHelpModalOpen] = useState(false);
    const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);

    const [hasChatted, setHasChatted] = useState(false);
    const showWelcome = !hasChatted;


    const handleCopy = useCallback(async (id: string, text: string) => {
        try {
            await navigator.clipboard.writeText(text);
        } catch {
        }
        showToast(id, "Copied!");
    }, [showToast]);

    const downloadText = useCallback((filename: string, text: string) => {
        const blob = new Blob([text], {type: "text/plain;charset=utf-8"});
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
    }, []);


    const mainRef  = useRef<HTMLDivElement | null>(null);
    const titleRef = useRef<HTMLDivElement | null>(null);
    const scrollRef = useRef<HTMLDivElement | null>(null);

    const scrollToBottom = useCallback(() => {
        const el = scrollRef.current;
        if (!el) return;
        requestAnimationFrame(() => {
            el.scrollTop = el.scrollHeight;
        });
    }, []);

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        const observer = new MutationObserver(() => {
            scrollToBottom();
        });

        observer.observe(el, {
            childList: true,
            subtree: true,
        });

        scrollToBottom();
        return () => observer.disconnect();
    }, [scrollToBottom]);

    useLayoutEffect(() => {
        const main  = mainRef.current;
        const title = titleRef.current;
        const msg   = scrollRef.current;
        if (!main || !title || !msg) return;

        title.style.boxSizing = 'border-box';
        title.style.position  = 'relative';

        const supportsGutter = CSS.supports?.('scrollbar-gutter: stable') ?? false;
        if (supportsGutter) {
            msg.style.overflowY = 'auto';
            msg.style.scrollbarGutter = 'stable';
        } else {
            msg.style.overflowY = 'scroll';
            (msg.style as any).scrollbarWidth = 'none';
            const attr = 'data-hidebar';
            msg.setAttribute(attr, '');
            const styleEl = document.createElement('style');
            styleEl.textContent = `
      [${attr}]::-webkit-scrollbar{ width:16px }
      [${attr}]::-webkit-scrollbar-thumb{ background:transparent }
      [${attr}]::-webkit-scrollbar-track{ background:transparent }
    `;
            document.head.appendChild(styleEl);
            (msg as any)._hidebarCleanup = () => {
                styleEl.remove();
                msg.removeAttribute(attr);
                (msg.style as any).scrollbarWidth = '';
            };
        }

        const measureAndFreeze = () => {
            msg.style.width = '';

            const mainRect = main.getBoundingClientRect();
            const msgRect  = msg.getBoundingClientRect();

            const left      = Math.max(0, Math.round(msgRect.left - mainRect.left));
            const contentW  = Math.max(0, Math.round(msg.clientWidth));
            const mainWidth = Math.max(0, Math.round(main.clientWidth));

            msg.style.width        = contentW + 'px';
            title.style.marginLeft = left + 'px';
            title.style.width      = Math.max(0, mainWidth - left) + 'px';
            scrollToBottom();
        };
        measureAndFreeze();
        window.addEventListener('resize', measureAndFreeze);
        return () => {
            window.removeEventListener('resize', measureAndFreeze);
            if ((msg as any)._hidebarCleanup) (msg as any)._hidebarCleanup();
        };
    }, [scrollToBottom]);


    const buildFeedbackPayload = (
        assistantMsgId: string,
        which: FeedbackKind,
        userNotes?: string[] | string | null,
    ): FeedbackPayload => {
        const aIdx = messages.findIndex(m => m.id === assistantMsgId && m.role === 'assistant');
        const answer_text = aIdx >= 0 ? messages[aIdx].text : '';
        const alias = sessionStorage.getItem('gobotCognitoAlias') || 'user123';

        let question_text = '';
        for (let i = aIdx - 1; i >= 0; i -= 1) {
            if (messages[i].role === 'user') {
                question_text = messages[i].text;
                break;
            }
        }

        return {
            user_alias: alias,
            feedback: which,
            user_notes: userNotes ?? null,
            question_text,
            answer_text,
            identifier: mode,
        };
    };

    const sendFeedback = async (assistantMsgId: string, which: FeedbackKind, notes?: string[] | string | null) => {
        try {
            const payload = buildFeedbackPayload(assistantMsgId, which, notes);
            await postFeedback(payload);
        } catch (e) {

        }
    };

    const handleSubmit = useCallback(async () => {
        const text = input.trim();
        if (!text || thinking) return;

        const userId = `${Date.now()}-u`;
        setMessages(m => [...m, { id: userId, role: "user", text }]);
        setHasChatted(true);
        setInput("");

        const assistantId = `${Date.now()}-a`;
        setMessages(m => [...m, { id: assistantId, role: "assistant", text: "" }]);
        setStreamingId(assistantId);
        setThinking(true);

        const normalizeSqlBlocks = (raw: string): string => {
            const lines = raw.split("\n");
            let inFence = false;
            let fenceLang = "";
            const out: string[] = [];
            let sqlBuffer = "";
            const pushSql = () => {
                const trimmed = sqlBuffer.trim();
                if (trimmed) out.push(trimmed);
                sqlBuffer = "";
            };
            lines.forEach(line => {
                const fenceMatch = /^\s*```(\w+)?/i.exec(line);
                if (fenceMatch) {
                    if (!inFence) {
                        inFence = true;
                        fenceLang = (fenceMatch[1] || "").toLowerCase();
                    } else {
                        if (fenceLang === "sql") pushSql();
                        inFence = false;
                        fenceLang = "";
                    }
                    return;
                }
                if (inFence && fenceLang === "sql") {
                    const t = line.trim();
                    if (t) sqlBuffer += (sqlBuffer ? " " : "") + t;
                    return;
                }
                out.push(line);
            });
            if (sqlBuffer) pushSql();
            return out.join("\n").replace(/\b```?\s*sql\b/gi, "").replace(/[ \t]+\n/g, "\n");
        };

        const commitLive = (fullText: string) => {
            const live = normalizeSqlBlocks(fullText);
            setMessages(m => m.map(msg => (msg.id === assistantId ? { ...msg, text: live } : msg)));
        };

        // get Cognito token
        const creds = await getCognitoJwtForGobot();
        if (!creds?.accessToken) {
            setMessages(m =>
                m.map(msg =>
                    msg.id === assistantId
                        ? { ...msg, text: "Error: please try again" }
                        : msg
                )
            );
            return;
        }
        const accessToken = creds.accessToken;
        const userAlias = creds.alias || "unknown";

        const modeForApi = apiMode[mode];
        const payload = {
            query: text,
            mode: modeForApi,
            user_id: userAlias,
            stream: true, // flip to false for non-streaming
        };
        const wantStream = !!payload.stream;

        try {
            const resp = await fetch(getChatUrl(), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: wantStream ? "text/event-stream" : "application/json",
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify(payload),
            });

            if (!resp.body && wantStream) {
                throw new Error(`No response body (HTTP ${resp.status})`);
            }

            // ---- STREAMING PATH ----
            if (wantStream) {
                const reader = resp.body!.getReader();
                const decoder = new TextDecoder("utf-8");

                type StreamPacket = { type?: string; content?: string };
                let buffer = "";
                let fullText = "";

                while (true) {
                    const { done, value } = await reader.read();
                    if (done) break;

                    buffer += decoder.decode(value ?? new Uint8Array(), { stream: true });
                    const events = buffer.split("\n\n");
                    buffer = events.pop() || "";

                    for (const evt of events) {
                        const dataLine = evt.split("\n").find(l => l.startsWith("data:"));
                        if (!dataLine) continue;

                        let pkt: StreamPacket | null = null;
                        try {
                            pkt = JSON.parse(dataLine.slice(5).trim()) as StreamPacket;
                        } catch {
                            pkt = null;
                        }

                        if (pkt?.type === "start") {
                            if (thinking) setThinking(false);
                        } else if (pkt?.type === "chunk" && typeof pkt.content === "string") {
                            if (thinking) setThinking(false);
                            fullText += pkt.content;
                            commitLive(fullText);
                        }
                    }
                }

                const cleaned = normalizeSqlBlocks(fullText || "");
                setMessages(m => {
                    const replaced = m.map(msg => (msg.id === assistantId ? { ...msg, text: cleaned } : msg));
                    return [...replaced, { id: `${Date.now()}-f`, role: "feedback", text: feedbackPrompt }];
                });
            }

            // ---- NON-STREAMING ----
            if (!wantStream) {
                const raw = await resp.text();
                let json: any = {};
                try { json = raw ? JSON.parse(raw) : {}; } catch {}
                if (!resp.ok || json.error) {
                    throw new Error(json.error_message || `HTTP ${resp.status}`);
                }
                if (thinking) setThinking(false);

                const fullText = String(json.response ?? "");
                commitLive(fullText);

                setMessages(m => [
                    ...m,
                    { id: `${Date.now()}-f`, role: "feedback", text: feedbackPrompt },
                ]);
            }
        } catch {
            setMessages(m =>
                m.map(msg => (msg.id === assistantId ? { ...msg, text: "Error: please try again" } : msg)),
            );
        } finally {
            setThinking(false);
            setStreamingId(null);
        }
    }, [input, thinking, mode, apiMode]);


    return (
        <Box className="pf-root">
            <div className="pf-topRule"/>
            <div className="pf-bodyRow">
                    <main className="pf-main" ref={mainRef} >
                    <div className="pf-chat"  aria-busy={thinking ? "true" : "false"}>
                        <div className="pf-title-rule" ref={titleRef}>
      <span className="pf-titleLabel">
        <img className="pf-badge" src={GOBOT_BADGE} alt=""/>
        <Text className="pf-titleText">Ask GoBot – Transforming Huron Data into Instant AI Insights.</Text>
      </span>
                            <div className="pf-title-underline"/>

                        </div>
                        <div className="pf-messagesWrap" ref={scrollRef}
                            style={{ paddingRight: 'var(--pf-sbw, 0px)' }}>
                            <div className="pf-messagesInner">
                                {showWelcome ? (
                                    <div className="pf-welcome">
                                        <div className="pf-welcomeTitle">How can I help you?</div>
                                        <div className="pf-welcomeSub">
                                            I'm your NASC virtual assistant. Ask me about anything about NASC related.
                                            I'm still learning - please give me feedback. To explore sample prompts on
                                            how can I help
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        {messages.map((m) => {
                                            if (m.role === "assistant") {
                                                const isStreamingThis = !!streamingId && m.id === streamingId && !m.text?.trim();
                                                if (!m.text?.trim() || isStreamingThis) return null;
                                                return (
                                                    <div key={m.id} className="pf-bubbleGroup">
                                                        <div className="pf-bubbleBase pf-bubbleAssistant">
                                                            {renderMd(m.text)}
                                                        </div>

                                                        <div className="pf-bubbleFooter">
                                                            <div className="pf-leftActions pf-leftActions--pos">
                                                                {toast && toast.id === m.id && (
                                                                    <div className="pf-toast" role="status" aria-live="polite">
                                                                        <span className="pf-toastCheck">✓</span>
                                                                        {toast.msg}
                                                                        <span className="pf-toastCaret" aria-hidden />
                                                                    </div>
                                                                )}

                                                                <button
                                                                    className="pf-linkBtn"
                                                                    onClick={() => handleCopy(m.id, m.text)}
                                                                    title="Copy to clipboard"
                                                                >
                                                                    <Icon tokens={copyTokens} />
                                                                </button>

                                                                <button
                                                                    className="pf-linkBtn"
                                                                    onClick={() => downloadText(`response-${m.id}.txt`, m.text)}
                                                                    title="Download response"
                                                                >
                                                                    <Icon tokens={downloadLargeTokens} />
                                                                </button>
                                                            </div>
                                                            <div className="pf-thumbWrap">
                                                                <button
                                                                    className={`pf-thumbBtn ${feedbackMap[m.id] === 'up' ? 'pf-thumbBtn--upSelected' : ''}`}
                                                                    aria-label="Helpful"
                                                                    onClick={() => {
                                                                        if (feedbackMap[m.id]) return;
                                                                        setFeedbackMap((prev) => ({ ...prev, [m.id]: 'up' }));
                                                                        void sendFeedback(m.id, 'ThumbsUp');
                                                                    }}
                                                                    disabled={thinking || !!feedbackMap[m.id]}
                                                                    title="Helpful"
                                                                >
                                                                    <Icon tokens={thumbsUpTokens} />
                                                                </button>
                                                            </div>
                                                            <div className="pf-thumbWrap">
                                                                <button
                                                                    className={`pf-thumbBtn ${feedbackMap[m.id] === 'down' ? 'pf-thumbBtn--downSelected' : ''}`}
                                                                    aria-label="Not helpful"
                                                                    onClick={() => {
                                                                        if (feedbackMap[m.id]) return;
                                                                        setFeedbackTargetId(m.id);
                                                                        setFeedbackModalOpen(true);
                                                                    }}
                                                                    disabled={thinking || !!feedbackMap[m.id]}
                                                                    title="Not helpful"
                                                                >
                                                                    <Icon tokens={thumbsDownTokens} />
                                                                </button>

                                                                <FeedbackModal
                                                                    open={feedbackModalOpen && feedbackTargetId === m.id}
                                                                    onClose={() => {
                                                                        if (feedbackTargetId && !feedbackMap[feedbackTargetId]) {
                                                                            setFeedbackMap((prev) => ({ ...prev, [feedbackTargetId]: 'down' }));
                                                                            void sendFeedback(feedbackTargetId, 'ThumbsDown', null);
                                                                        }
                                                                        setFeedbackModalOpen(false);
                                                                        setFeedbackTargetId(null);
                                                                    }}
                                                                    onSubmit={(reasons: string[] | string) => {

                                                                        if (!feedbackMap[m.id]) {
                                                                            setFeedbackMap((prev) => ({ ...prev, [m.id]: 'down' }));
                                                                            void sendFeedback(m.id, 'ThumbsDown', reasons);
                                                                        }
                                                                        setFeedbackModalOpen(false);
                                                                        setFeedbackTargetId(null);
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            }

                                            if (m.role === "user") {
                                                return (
                                                    <div key={m.id} className="pf-bubbleBase pf-bubbleUser" style={{ marginLeft: "auto" }}>
                                                        <Text>{m.text}</Text>
                                                    </div>
                                                );
                                            }

                                            return null;
                                        })}

                                        {thinking &&
                                            !(
                                                messages[messages.length - 1]?.role === 'assistant' &&
                                                (messages[messages.length - 1]?.text?.length ?? 0) > 0
                                            ) && (
                                                <div className="pf-bubbleBase pf-bubbleAssistant" style={{ marginRight: "auto" }}>
                                                    <div className="pf-thinkingWrap">
                                                        <span className="pf-thinkingText">Thinking</span>
                                                        <div className="pf-threeDots"><span></span><span></span><span></span></div>
                                                    </div>
                                                </div>
                                            )}
                                    </>
                                )}
                                {showWelcome && (
                                    <div className="pf-suggestWrap">
                                        <div className={`pf-suggestRow ${thinking ? "is-disabled" : ""}`} role="list">
                                            {SUGGESTIONS.map((q, i) => (
                                                <button
                                                    key={i}
                                                    type="button"
                                                    className="pf-suggestBtn"
                                                    onClick={() => onPickSuggestion(q)}
                                                    disabled={thinking}
                                                    role="listitem"
                                                    aria-label={`Insert: ${q}`}
                                                >
                                                    <Box type="outline" spacingInset="none" className="pf-suggestBox">
                                                        <Text type="b300">{q}</Text>
                                                    </Box>
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Mode selector */}


                        <div className={`pf-modeBar ${thinking ? "is-disabled" : ""}`} aria-disabled={thinking}>
                            <div className="pf-seg" role="tablist" aria-label="Mode selector">

                                <button
                                    type="button"
                                    className={`pf-segBtn ${mode === "sitesInformation" ? "is-active" : ""}`}
                                    onClick={() => !thinking && setMode("sitesInformation")}
                                    aria-pressed={mode === "sitesInformation"}
                                    disabled={thinking}
                                    tabIndex={thinking ? -1 : 0}
                                >
                                    Site Intelligence
                                </button>
                                <button
                                    type="button"
                                    className={`pf-segBtn ${mode === "general" ? "is-active" : ""}`}
                                    onClick={() => !thinking && setMode("general")}
                                    aria-pressed={mode === "general"}
                                    disabled={thinking}
                                    tabIndex={thinking ? -1 : 0}
                                >
                                    General
                                </button>
                            </div>
                            <Button type='icon' size='small' onClick={() => setHelpModalOpen(true)}>
                                <Icon tokens={infoKnockoutTokens} className="pf-modeIcon"/>
                            </Button>
                            <HelpModal open={helpModalOpen} onClose={() => setHelpModalOpen(false)}/>
                        </div>

                        <div className={`pf-inputBar ${thinking ? "is-disabled" : ""}`}>
                            <div className={`pf-inputBubble ${input.trim() ? "pf-inputBubble--active" : ""}`}>
        <textarea
            className="pf-nativeTextarea"
            placeholder={MODE_PLACEHOLDER[mode]}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => {
                if (thinking) return;
                if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    handleSubmit();
                }
            }}
            disabled={thinking}
            aria-disabled={thinking}
        />
                                <button
                                    type="button"
                                    className={`pf-sendButton ${input.trim() && !thinking ? "pf-sendButton--enabled" : "pf-sendButton--disabled"}`}
                                    disabled={thinking || !input.trim()}
                                    onClick={handleSubmit}
                                    aria-label="Send message"
                                >
                                    <svg className="pf-sendSvg" viewBox="0 0 24 24" aria-hidden="true">
                                        <path d="M2 21l21-9L2 3v7l15 2-15 2v7z"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </Box>
    );
}
